import React from 'react';
import {
  View,
  Text,
  TextInput,
  StyleSheet,
} from 'react-native';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';
import { postItemStrings } from '@/constants/residents/marketplaceStrings';
import { INPUT_LIMITS } from '@/constants/residents/marketplaceConstants';
import { PostItemFormData } from '@/types/residents/marketplaceListing';
import { StepHeader, postItemStyles } from './shared';

interface StepItemDetailsProps {
  formData: PostItemFormData;
  onFormChange: (updates: Partial<PostItemFormData>) => void;
}

export const StepItemDetails: React.FC<StepItemDetailsProps> = ({
  formData,
  onFormChange,
}) => {
  const MARKETPLACE_COLORS = useMarketplaceColors();

  return (
    <View style={postItemStyles.container}>
      <StepHeader title={postItemStrings.whatAreSelling} />

      <View style={styles.fields}>
        {/* Title Input */}
        <View style={[
          styles.inputContainer,
          {
            backgroundColor: MARKETPLACE_COLORS.inputBackground,
            borderColor: MARKETPLACE_COLORS.inputBorder,
          },
          formData.title.length > 0 && styles.inputContainerFilled,
        ]}>
          <View style={styles.inputContent}>
            <Text style={[styles.inputLabel, { color: MARKETPLACE_COLORS.textSecondary }]}>{postItemStrings.briefTitle}</Text>
            <TextInput
              style={[styles.input, { color: MARKETPLACE_COLORS.textPrimary }]}
              value={formData.title}
              onChangeText={(text) => onFormChange({ title: text })}
              placeholder=""
              placeholderTextColor={MARKETPLACE_COLORS.textSecondary}
              maxLength={INPUT_LIMITS.title}
            />
          </View>
        </View>

        {/* Description Input */}
        <View style={[
          styles.textareaContainer,
          {
            backgroundColor: MARKETPLACE_COLORS.inputBackground,
            borderColor: MARKETPLACE_COLORS.inputBorder,
          },
        ]}>
          <TextInput
            style={[styles.textarea, { color: MARKETPLACE_COLORS.textPrimary }]}
            value={formData.description}
            onChangeText={(text) => onFormChange({ description: text })}
            placeholder={postItemStrings.descriptionOptional}
            placeholderTextColor={MARKETPLACE_COLORS.textSecondary}
            multiline
            numberOfLines={4}
            textAlignVertical="top"
            maxLength={INPUT_LIMITS.description}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  fields: {
    paddingHorizontal: 24,
    gap: 16,
  },
  inputContainer: {
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 16,
    height: 40,
    justifyContent: 'center',
  },
  inputContainerFilled: {
    height: 52,
    paddingTop: 4,
    justifyContent: 'flex-start',
  },
  inputContent: {
    flex: 1,
    justifyContent: 'center',
  },
  inputLabel: {
    fontSize: 10,
    fontWeight: '600',
    lineHeight: 12.5,
  },
  input: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 17.5,
    padding: 0,
    margin: 0,
  },
  textareaContainer: {
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    height: 80,
  },
  textarea: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 17.5,
    flex: 1,
    padding: 0,
    margin: 0,
  },
});
